export default __webpack_public_path__ + "static/media/agent-role-scout-green.0620f251.svg";